export default __webpack_public_path__ + "static/media/berkshire-hathaway.99687d75.svg";